import React from "react"

import Tooltip from "src/components/Tooltip"

const ByLengthEstimateWarning = () => (
  <Tooltip
    placement="bottom"
    maxWidth="350px"
    variant="dark"
    text="Estimate excludes per ft or per sqft items — these are automatically calculated when this template is applied to a specific boat on a work order."
  >
    <i className="fa-regular fa-triangle-exclamation cursor-pointer text-gray-600" />
  </Tooltip>
)

export default ByLengthEstimateWarning
